import { useCallback } from 'react'
import cn from 'classnames'

import useCallbackRef from 'app/common/hooks/useCallbackRef'

import Picture from '../picture'
import PlainButton from '../plain-button'
import { PlainConfirm } from '../plain-confirm-modal'

import styles from './image-clickable.module.scss';


type Props = {
  className?: string
  id: string
  imageUrl: string
  description: string
  locked?: boolean
  deleteMessage?: string
  onReplace?: (id: string) => void
  onDelete?: (id: string) => Promise<boolean>
}

export const ImageClickable = ({
  className,
  id,
  imageUrl,
  description,
  locked,
  deleteMessage = 'Удалить изображение?',
  onReplace,
  onDelete,
}: Props) => {
  const onDeleteRef = useCallbackRef(onDelete)

  const handleDelete = useCallback(async () => {
    const res = await onDeleteRef.current?.(id)
    return res || false
  }, [onDeleteRef, id])

  return (
    <div className={cn(styles.root, className)}>
      <Picture
        className={styles.picture}
        src={imageUrl}
        alt={description}
        width="100%"
      />

      {!locked
        && <div className={styles.overlay}>
          <div className={styles.item}>
            <PlainButton
              className={styles.button}
              onClick={onReplace ? () => onReplace(id) : undefined}
            >
              {'Изменить'}
            </PlainButton>
          </div>
          <div className={styles.item}>
            <PlainConfirm
              messageText={deleteMessage}
              confirmButtonTitle="Удалить"
              confirmButtonTitlePending="Удаление..."
              onConfirm={handleDelete}
              critical
            >
              {beginConfirmation => (
                <PlainButton
                  className={styles.button}
                  onClick={beginConfirmation}
                  danger
                >
                  {'Удалить'}
                </PlainButton>
              )}
            </PlainConfirm>
          </div>
        </div>}
    </div>
  )
}
